import React from 'react';
import PropTypes from 'prop-types';

class PipelineStepWrapper extends React.Component {
  constructor(props) {
    super(props)
  }
  static propTypes = {
    completed : PropTypes.bool,
  }
  render() {
    const {completed, className} = this.props;
    return <div className="row">
      <div className="col-xs-2 col-md-1">
      {!completed ? (
        <i className={`${className} fa fa-4x fa-check-circle text-muted`}></i>
      ) : (
        <i className={`${className} fa fa-4x fa-check-circle text-success`}></i>
      )}
      </div>
      <div className="col-xs-10 col-md-11">
       {this.props.children}
      </div>
   </div>
  }
}

export default PipelineStepWrapper;



// WEBPACK FOOTER //
// ./src/browser/components/pipeline/pipeline-step-wrapper.js